import { Typography } from '@mui/material';
import { Link } from 'react-router-dom';

import type { SystemLinksProps } from 'applications/GSP/entities/SystemLinks/SystemLinks';
import type { FC, PropsWithChildren } from 'react';

interface SystemLinkProps
  extends PropsWithChildren,
    Pick<SystemLinksProps, 'onClick'> {
  path: string;
}

export const SystemLink: FC<SystemLinkProps> = ({
  children,
  path,
  onClick,
}) => (
  <Typography
    to={path}
    component={Link}
    variant="caption"
    sx={{ textDecoration: 'none', color: 'text.secondary' }}
    onClick={onClick}
  >
    {children}
  </Typography>
);
